import _regenerator from "/usr/app/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/usr/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import fetcher from "@/common/axiosInstance";
export var api__getDhamenFormData = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(_ref) {
    var order_uuid, res;
    return _regenerator().w(function (_context) {
      while (1) switch (_context.n) {
        case 0:
          order_uuid = _ref.order_uuid;
          _context.n = 1;
          return fetcher(null, true).get("/dhamen/get-details?uuid=".concat(order_uuid));
        case 1:
          res = _context.v;
          return _context.a(2, res.data || null);
      }
    }, _callee);
  }));
  return function api__getDhamenFormData(_x) {
    return _ref2.apply(this, arguments);
  };
}();
export var api__validateUserData = /*#__PURE__*/function () {
  var _ref4 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(_ref3) {
    var id_number, date_of_birth, date_of_birth_h, date_of_birth_type, first_name, last_name, res;
    return _regenerator().w(function (_context2) {
      while (1) switch (_context2.n) {
        case 0:
          id_number = _ref3.id_number, date_of_birth = _ref3.date_of_birth, date_of_birth_h = _ref3.date_of_birth_h, date_of_birth_type = _ref3.date_of_birth_type, first_name = _ref3.first_name, last_name = _ref3.last_name;
          _context2.n = 1;
          return fetcher(null, true).post("/dhamen/validate", {
            id_number: id_number,
            date_of_birth: date_of_birth,
            date_of_birth_h: date_of_birth_h,
            date_of_birth_type: date_of_birth_type,
            first_name: first_name,
            last_name: last_name
          });
        case 1:
          res = _context2.v;
          return _context2.a(2, (res === null || res === void 0 ? void 0 : res.data) || null);
      }
    }, _callee2);
  }));
  return function api__validateUserData(_x2) {
    return _ref4.apply(this, arguments);
  };
}();
export var api__submitDhamenFormData = /*#__PURE__*/function () {
  var _ref6 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(_ref5) {
    var uuid, first_name, last_name, date_of_birth, date_of_birth_h, date_of_birth_type, id_number, monthly_income, period, first_payment, monthly_commitments, requested_financing_amount, res;
    return _regenerator().w(function (_context3) {
      while (1) switch (_context3.n) {
        case 0:
          uuid = _ref5.uuid, first_name = _ref5.first_name, last_name = _ref5.last_name, date_of_birth = _ref5.date_of_birth, date_of_birth_h = _ref5.date_of_birth_h, date_of_birth_type = _ref5.date_of_birth_type, id_number = _ref5.id_number, monthly_income = _ref5.monthly_income, period = _ref5.period, first_payment = _ref5.first_payment, monthly_commitments = _ref5.monthly_commitments, requested_financing_amount = _ref5.requested_financing_amount;
          _context3.n = 1;
          return fetcher(null, true).post("/dhamen/financing-requests", {
            id_number: id_number,
            uuid: uuid,
            first_name: first_name,
            last_name: last_name,
            date_of_birth: date_of_birth,
            date_of_birth_h: date_of_birth_h,
            date_of_birth_type: date_of_birth_type,
            monthly_income: monthly_income,
            period: period,
            first_payment: first_payment,
            monthly_commitments: monthly_commitments,
            requested_financing_amount: requested_financing_amount
          });
        case 1:
          res = _context3.v;
          return _context3.a(2, (res === null || res === void 0 ? void 0 : res.data) || null);
      }
    }, _callee3);
  }));
  return function api__submitDhamenFormData(_x3) {
    return _ref6.apply(this, arguments);
  };
}();
export var api__respondToDhamenOffer = /*#__PURE__*/function () {
  var _ref8 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(_ref7) {
    var uuid, response_status, res;
    return _regenerator().w(function (_context4) {
      while (1) switch (_context4.n) {
        case 0:
          uuid = _ref7.uuid, response_status = _ref7.response_status;
          _context4.n = 1;
          return fetcher(null, true).post("/dhamen/financing-request-response", {
            uuid: uuid,
            response_status: response_status
          });
        case 1:
          res = _context4.v;
          return _context4.a(2, (res === null || res === void 0 ? void 0 : res.data) || null);
      }
    }, _callee4);
  }));
  return function api__respondToDhamenOffer(_x4) {
    return _ref8.apply(this, arguments);
  };
}();